import TheaterMasksIcon from "../images/TheaterMasksIcon.mjs";

/**
 * App icon representing synthetic data (fake test data)
 * @see {GlyphIcon}
 * @see {TheaterMasksIcon}
 */
const AppSynthDataIcon = class extends TheaterMasksIcon {}

export default AppSynthDataIcon;